import { api } from '@services';

interface IResponse {
  totalAssets: number;
  totalUsers: number;
  totalManufacturers: number;
}

const indexStudioNumbers = async (): Promise<IResponse> => {
  const { data: totalAssets } = await api.get<IResponse>(
    `/studios/totalMetricsData`,
  );

  return totalAssets;
};

export { indexStudioNumbers };
